// import React, { useEffect, useState, useMemo } from 'react';
// import axios from 'axios';
// import { Box, Typography, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
// import TableComponent from '../../Components/TableComponent/TableComponent';
// import { SnackBarComponent } from '../../Components/snackBar/snackBar';
// import { LoadingSpinner } from '../../Components/spinner/spinner';
// import { API_BASE_URL } from '../../config';
// import { useTranslation } from 'react-i18next';

// export const DailyCourtCasesComponent = () => {
//   const { t } = useTranslation();

//   const [rows, setRows] = useState([]);
//   const [filteredRows, setFilteredRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');
//   const [selectedStatus, setSelectedStatus] = useState('all');

//   const columns = [
//     { id: 'slNo', field: 'slNo', headerName: t('dailyCourt.slNo'), width: 20 },
//     { id: 'case_no', field: 'case_no', headerName: t('dailyCourt.caseNo'), width: 100 },
//     { id: 'kpid_sec', field: 'kpid_sec', headerName: t('dailyCourt.kpidSec'), width: 100 },
//     { id: 'petitioner', field: 'petitioner', headerName: t('dailyCourt.petitioner'), width: 150 },
//     { id: 'respondants', field: 'respondants', headerName: t('dailyCourt.respondants'), width: 150 },
//     { id: 'status', field: 'status', headerName: t('dailyCourt.status'), width: 140 }
//   ];

//   // Updated priority statuses (including new ones)
//   const priorityStatuses = [
//     'stayinhighcourtofKarnataka',
//     'notice',
//     'disposed',
//     'orders',
//     'evidence',
//     'arguments',
//     'objection',
//     'writtenstatement',
//     'summons',
//     'hearing'
//   ];

//   const normalizeStatus = (status) => {
//     if (!status) return '';
//     return status.toLowerCase().replace(/\s+/g, '');
//   };

//   const getUniqueStatuses = (data) => {
//     const statusSet = new Set();
//     data.forEach(item => {
//       if (item.originalStatus) {
//         const normalized = normalizeStatus(item.originalStatus);
//         statusSet.add(normalized);
//       }
//     });
//     return Array.from(statusSet);
//   };

//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/home-notification/daily-court-orders/`)
//       .then((response) => {
//         const apiData = response.data.map((item, index) => ({
//           id: item.id || index,
//           slNo: index + 1,
//           case_no: item.case_no,
//           kpid_sec: item.kpid_sec,
//           petitioner: item.petitioner,
//           respondants: item.respondants,
//           status: item.status || '',
//           originalStatus: item.status || '',
//           normalizedStatus: normalizeStatus(item.status),
//         }));
//         setRows(apiData);
//         setFilteredRows(apiData);
//         setSnackbarMessage(t('dailyCourt.successMessage'));
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error('Failed to fetch daily court cases:', error);
//         setSnackbarMessage(t('dailyCourt.errorMessage'));
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         setLoading(false);
//       });
//   }, [t]);

//   useEffect(() => {
//     if (selectedStatus === 'all') {
//       setFilteredRows(rows);
//     } else if (selectedStatus === 'others') {
//       const prioritySet = new Set(priorityStatuses);
//       const otherRows = rows.filter(row => row.normalizedStatus && !prioritySet.has(row.normalizedStatus));
//       setFilteredRows(otherRows);
//     } else {
//       const filtered = rows.filter(row => row.normalizedStatus === selectedStatus);
//       setFilteredRows(filtered);
//     }
//   }, [rows, selectedStatus]);

//   const statusOptions = useMemo(() => {
//     const uniqueStatuses = getUniqueStatuses(rows);
//     const options = ['all'];
//     priorityStatuses.forEach(status => {
//       if (uniqueStatuses.includes(status)) options.push(status);
//     });
//     options.push('others');
//     return options;
//   }, [rows]);

//   const handleStatusChange = (event) => {
//     setSelectedStatus(event.target.value);
//   };

//   const handleSnackbarClose = () => {
//     setSnackbarOpen(false);
//   };

//   if (loading) {
//     return <LoadingSpinner size={30} />;
//   }

//   return (
//     <Box sx={{ width: '100%', mt: 8, mb: 1, borderRadius: 2, boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', backgroundColor: '#fff', position: 'relative' }}>
//       <Box display="flex" justifyContent="center" backgroundColor="rgba(195, 234, 203, 0.1)" mb={2}>
//         <Typography variant="h4" component="h1" align="center" sx={{ fontWeight: 'bold' }}>
//           {t('dailyCourt.heading')}
//         </Typography>
//       </Box>

//       <Box sx={{ display: 'flex', justifyContent: 'flex-end', px: 2, mb: 1 }}>
//         <FormControl size="small" sx={{ minWidth: 140 }}>
//           <InputLabel sx={{ fontSize: '0.75rem' }}>Status</InputLabel>
//           <Select value={selectedStatus} label="Status" onChange={handleStatusChange} sx={{ fontSize: '0.8rem' }}>
//             <MenuItem value="all">All</MenuItem>
//             {statusOptions.filter(opt => opt !== 'all' && opt !== 'others').map((status) => (
//               <MenuItem key={status} value={status} sx={{ fontSize: '0.8rem' }}>
//                 {rows.find(r => r.normalizedStatus === status)?.status || status}
//               </MenuItem>
//             ))}
//             <MenuItem value="others">Others</MenuItem>
//           </Select>
//         </FormControl>
//       </Box>

//       <TableComponent
//         columns={columns}
//         rows={filteredRows}
//         manageColumnStatus={true}
//         enableSort={true}
//       />

//       <SnackBarComponent open={snackbarOpen} message={snackbarMessage} severity={snackbarSeverity} onClose={handleSnackbarClose} />
//     </Box>
//   );
// };



import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { Box, Typography, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import TableComponent from '../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../Components/snackBar/snackBar';
import { LoadingSpinner } from '../../Components/spinner/spinner';
import { API_BASE_URL } from '../../config';
import { useTranslation } from 'react-i18next';

export const DailyCourtCasesComponent = () => {
  const { t } = useTranslation();

  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');
  const [selectedStatus, setSelectedStatus] = useState('all');

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: t('dailyCourt.slNo'), width: 20 },
    { id: 'case_no', field: 'case_no', headerName: t('dailyCourt.caseNo'), width: 100 },
    { id: 'kpid_sec', field: 'kpid_sec', headerName: t('dailyCourt.kpidSec'), width: 100 },
    { id: 'petitioner', field: 'petitioner', headerName: t('dailyCourt.petitioner'), width: 150 },
    { 
      id: 'advocate_name', 
      field: 'advocate_name', 
      headerName: t('highCourt.advocateName') , 
      width: 140 
    },
    { id: 'respondants', field: 'respondants', headerName: t('dailyCourt.respondants'), width: 150 },
    { 
      id: 'date_of_filling', 
      field: 'date_of_filling', 
      headerName: t('highCourt.dateOfFilling'), 
      width: 120 
    },
    { 
      id: 'previous_date_of_hearing', 
      field: 'previous_date_of_hearing', 
      headerName:t('highCourt.previousDate'), 
      width: 130 
    },
    { 
      id: 'next_date_of_hearing', 
      field: 'next_date_of_hearing', 
      headerName: t('highCourt.nextDate'),
      width: 130 
    },
  
    { 
      id: 'appearence_by', 
      field: 'appearence_by', 
      headerName: t('highCourt.apearenceBY'), 
      width: 140 
    },
    { id: 'status', field: 'status', headerName: t('dailyCourt.status'), width: 140 },
    {
  id: 'links',
  field: 'links',
  headerName: t('advertisement.links'),
  width: 120,
  renderCell: (params) => {
    if (!params.value) {
      return <span>Not Found</span>;
    }
    return (
      <a href={params.value} target="_blank" rel="noopener noreferrer">
        {t('advertisement.download')}
      </a>
    );
  },
},

    
  ];

  // Updated priority statuses (including new ones)
  const priorityStatuses = [
    'stayinhighcourtofKarnataka',
    'notice',
    'disposed',
    'orders',
    'evidence',
    'arguments',
    'objection',
    'writtenstatement',
    'summons',
    'hearing'
  ];

    const formatDate = (dateString) => {
    if (!dateString || typeof dateString !== 'string') return dateString || '-';
    
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString; // Return original if invalid
    
    return date.toLocaleDateString('en-GB').replace(/\//g, '-');
  };

  const normalizeStatus = (status) => {
    if (!status) return '';
    return status.toLowerCase().replace(/\s+/g, '');
  };

  const getUniqueStatuses = (data) => {
    const statusSet = new Set();
    data.forEach(item => {
      if (item.originalStatus) {
        const normalized = normalizeStatus(item.originalStatus);
        statusSet.add(normalized);
      }
    });
    return Array.from(statusSet);
  };

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/home-notification/daily-court-orders/`)
      .then((response) => {
        const apiData = response.data.map((item, index) => ({
          id: item.id || index,
          slNo: index + 1,
          case_no: item.case_no,
          kpid_sec: item.kpid_sec,
          petitioner: item.petitioner,
          respondants: item.respondants,
          date_of_filling: formatDate(item.date_of_filling),
          previous_date_of_hearing: formatDate(item.previous_date_of_hearing),
          next_date_of_hearing: formatDate(item.next_date_of_hearing),
          advocate_name: item.advocate_name,
          appearence_by: item.appearence_by,
          status: item.status || '',
          originalStatus: item.status || '',
          normalizedStatus: normalizeStatus(item.status),
          // link: item.link
          links: item.link
        }));
        setRows(apiData);
        setFilteredRows(apiData);
        setSnackbarMessage(t('dailyCourt.successMessage'));
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Failed to fetch daily court cases:', error);
        setSnackbarMessage(t('dailyCourt.errorMessage'));
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLoading(false);
      });
  }, [t]);

  useEffect(() => {
    if (selectedStatus === 'all') {
      setFilteredRows(rows);
    } else if (selectedStatus === 'others') {
      const prioritySet = new Set(priorityStatuses);
      const otherRows = rows.filter(row => row.normalizedStatus && !prioritySet.has(row.normalizedStatus));
      setFilteredRows(otherRows);
    } else {
      const filtered = rows.filter(row => row.normalizedStatus === selectedStatus);
      setFilteredRows(filtered);
    }
  }, [rows, selectedStatus]);

  const statusOptions = useMemo(() => {
    const uniqueStatuses = getUniqueStatuses(rows);
    const options = ['all'];
    priorityStatuses.forEach(status => {
      if (uniqueStatuses.includes(status)) options.push(status);
    });
    options.push('others');
    return options;
  }, [rows]);

  const handleStatusChange = (event) => {
    setSelectedStatus(event.target.value);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  if (loading) {
    return <LoadingSpinner size={30} />;
  }

  return (
    <Box sx={{ width: '100%', mt: 8, mb: 1, borderRadius: 2, boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', backgroundColor: '#fff', position: 'relative' }}>
      <Box display="flex" justifyContent="center" backgroundColor="rgba(195, 234, 203, 0.1)" mb={2}>
        <Typography variant="h4" component="h1" align="center" sx={{ fontWeight: 'bold' }}>
          {t('dailyCourt.heading')}
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', px: 2, mb: 1 }}>
        <FormControl size="small" sx={{ minWidth: 140 }}>
          <InputLabel sx={{ fontSize: '0.75rem' }}>Status</InputLabel>
          <Select value={selectedStatus} label="Status" onChange={handleStatusChange} sx={{ fontSize: '0.8rem' }}>
            <MenuItem value="all">All</MenuItem>
            {statusOptions.filter(opt => opt !== 'all' && opt !== 'others').map((status) => (
              <MenuItem key={status} value={status} sx={{ fontSize: '0.8rem' }}>
                {rows.find(r => r.normalizedStatus === status)?.status || status}
              </MenuItem>
            ))}
            <MenuItem value="others">Others</MenuItem>
          </Select>
        </FormControl>
      </Box>

      <TableComponent
        columns={columns}
        rows={filteredRows}
        manageColumnStatus={true}
        enableSort={true}
      />

      <SnackBarComponent open={snackbarOpen} message={snackbarMessage} severity={snackbarSeverity} onClose={handleSnackbarClose} />
    </Box>
  );
};
